// Modal accesible del Design System (re-exportado para compatibilidad
// con `import { Modal } from '../components/common'`).
export { Modal } from '../ui/Modal'

export const Loading = ({ fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-canvas flex items-center justify-center z-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-[3px] border-slate-200 border-t-brand-primary mx-auto"></div>
          <p className="mt-4 text-ink-soft font-medium">Cargando…</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center p-8">
      <div className="animate-spin rounded-full h-12 w-12 border-[3px] border-slate-200 border-t-brand-primary"></div>
    </div>
  )
}

export const StatCard = ({ title, value, subtitle, icon, color = 'blue' }) => {
  const colors = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    yellow: 'bg-yellow-100 text-yellow-600',
    red: 'bg-red-100 text-red-600',
    purple: 'bg-purple-100 text-purple-600'
  }

  return (
    <div className="stat-card">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
          {subtitle && (
            <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${colors[color]}`}>
          {icon}
        </div>
      </div>
    </div>
  )
}

export const ActivityList = ({ activities }) => {
  if (activities.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No hay actividad reciente
      </div>
    )
  }

  const getIcon = (tipo) => {
    const icons = {
      medicamentos: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
      alimentos: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      default: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
        </svg>
      )
    }
    return icons[tipo] || icons.default
  }

  const getEstadoBadge = (estado) => {
    const styles = {
      pendiente: 'bg-yellow-100 text-yellow-800',
      entregado: 'bg-green-100 text-green-800',
      aprobado: 'bg-blue-100 text-blue-800'
    }
    return styles[estado] || 'bg-gray-100 text-gray-800'
  }

  return (
    <div className="divide-y divide-gray-200">
      {activities.map((activity) => (
        <div key={activity.id} className="p-4 hover:bg-gray-50 transition-colors">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                activity.organismo === 'hospital' ? 'bg-hospital-100 text-hospital-600' : 'bg-social-100 text-social-600'
              }`}>
                {getIcon(activity.tipo)}
              </div>
              <div>
                <p className="font-medium text-gray-900">
                  {activity.persona_apellido}, {activity.persona_nombre}
                </p>
                <p className="text-sm text-gray-500 capitalize">
                  {activity.tipo?.replace(/_/g, ' ')} • {new Date(activity.fecha).toLocaleDateString('es-AR')}
                </p>
              </div>
            </div>
            <span className={`badge ${getEstadoBadge(activity.estado)}`}>
              {activity.estado}
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}

